// extracted by mini-css-extract-plugin
module.exports = {"group":"form_group_group__2-7q4","title":"form_group_title__1T-ra","content":"form_group_content__1Fj1C"};